import { render, staticRenderFns } from "./CaseHeaderNew.vue?vue&type=template&id=2b91d40d"
import script from "./CaseHeaderNew.vue?vue&type=script&lang=js"
export * from "./CaseHeaderNew.vue?vue&type=script&lang=js"
import style0 from "./CaseHeaderNew.vue?vue&type=style&index=0&id=2b91d40d&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports